module.exports = __webpack_public_path__ + "img/Mask-group1.da7f33f7.png";